import blueWallet from './paddedWallet.png';
export type BlueWalletProps = JSX.IntrinsicElements['img'];
export const BlueWallet = ({ className, ...props }: BlueWalletProps) => (
  <img
    src={blueWallet}
    alt="blue wallet"
    width={800}
    height={800}
    className={className}
    {...props}
  />
);
